import { Link } from "react-router-dom";

function ServiceRequestConfirmation() {
  return (
    <div>
      <h4>
        Thank you for your submission. A member of our team will contact you soon. Normally, it takes up to 10-14 business days for an
        address review to be completed.
      </h4>
      <div className='container d-flex justify-content-end mb-5 mt-5'>
        <Link to='/' className='btn btn-primary btn-sm'>
          Return to Address Search
        </Link>
      </div>
    </div>
  );
}

export default ServiceRequestConfirmation;
